import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_profile_details",
  "aria-expanded": "true",
  "aria-controls": "kt_account_profile_details"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label fw-bold fs-6 text-uppercase" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label fw-bold fs-6 text-uppercase" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_23 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton1",
  class: "btn btn-dark-blue"
}
const _hoisted_24 = { class: "indicator-label" }
const _hoisted_25 = { class: "indicator-progress" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_27 = { class: "card mb-5 mb-xl-10" }
const _hoisted_28 = {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_signin_method"
}
const _hoisted_29 = { class: "card-title m-0" }
const _hoisted_30 = { class: "fw-boldest m-0" }
const _hoisted_31 = {
  id: "kt_account_signin_method",
  class: "collapse show"
}
const _hoisted_32 = { class: "card-body border-top p-9" }
const _hoisted_33 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Email", -1)
const _hoisted_35 = { class: "fs-6 fw-bold text-gray-600" }
const _hoisted_36 = { class: "row mb-6" }
const _hoisted_37 = { class: "col-lg-6 mb-4 mb-lg-0" }
const _hoisted_38 = { class: "fv-row mb-0" }
const _hoisted_39 = {
  for: "email",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "col-lg-6" }
const _hoisted_43 = { class: "fv-row mb-0" }
const _hoisted_44 = {
  for: "password",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_45 = { class: "fv-plugins-message-container" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = { class: "d-flex" }
const _hoisted_48 = {
  id: "kt_signin_submit",
  type: "submit",
  ref: "updateEmailButton",
  class: "btn btn-dark-blue me-2 px-6"
}
const _hoisted_49 = { class: "indicator-label" }
const _hoisted_50 = { class: "indicator-progress" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_52 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Password", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600" }, "************", -1)
const _hoisted_55 = [
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = { class: "fs-6 fw-bold text-gray-600 mb-4" }
const _hoisted_57 = { class: "row mb-6" }
const _hoisted_58 = { class: "col-lg-4" }
const _hoisted_59 = { class: "fv-row mb-0" }
const _hoisted_60 = {
  for: "currentpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_61 = { class: "fv-plugins-message-container" }
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = { class: "col-lg-4" }
const _hoisted_64 = { class: "fv-row mb-0" }
const _hoisted_65 = {
  for: "newpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_66 = { class: "fv-plugins-message-container" }
const _hoisted_67 = { class: "fv-help-block" }
const _hoisted_68 = { class: "col-lg-4" }
const _hoisted_69 = { class: "fv-row mb-0" }
const _hoisted_70 = {
  for: "confirmpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_71 = { class: "fv-plugins-message-container" }
const _hoisted_72 = { class: "fv-help-block" }
const _hoisted_73 = { class: "d-flex" }
const _hoisted_74 = {
  id: "kt_password_submit",
  type: "submit",
  ref: "updatePasswordButton",
  class: "btn btn-dark-blue me-2 px-6"
}
const _hoisted_75 = { class: "indicator-label" }
const _hoisted_76 = { class: "indicator-progress" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate("LABEL_USER_PROFILE")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          novalidate: "novalidate",
          onSubmit: _ctx.updateUserProfile,
          "validation-schema": _ctx.profileDetailsValidator
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate("USER_ACCOUNT_USERNAME_STRING")), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "user_name",
                    class: "form-control form-control-lg",
                    placeholder: "",
                    modelValue: _ctx.userName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userName) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_ErrorMessage, { name: "user_name" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.translate("USER_COMPANY_ROLE_STRING")) + " (" + _toDisplayString(_ctx.translate("OPTIONAL")) + ")", 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_Field, {
                    type: "tel",
                    name: "ruolo_aziendale",
                    class: "form-control form-control-lg",
                    placeholder: "",
                    modelValue: _ctx.userRole,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userRole) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_ErrorMessage, { name: "ruolo_aziendale" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate("USER_ACCOUNT_TELEPHONE_STRING")) + " (" + _toDisplayString(_ctx.translate("OPTIONAL")) + ")", 1),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "telefono",
                    class: "form-control form-control-lg",
                    placeholder: "",
                    modelValue: _ctx.userPhone,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userPhone) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_ErrorMessage, { name: "telefono" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetFields && _ctx.resetFields(...args))),
                class: "btn fw-bold btn-outline"
              }, _toDisplayString(_ctx.translate("BUTTON_DISCARD_CHANGES")), 1),
              _createElementVNode("button", _hoisted_23, [
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.translate("BUTTON_SAVE_CHANGES")), 1),
                _createElementVNode("span", _hoisted_25, [
                  _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_WAIT")) + " ", 1),
                  _hoisted_26
                ])
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("h3", _hoisted_30, _toDisplayString(_ctx.translate("UPDATE_LOGIN_CREDENTIAL")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", {
              id: "kt_signin_email",
              class: _normalizeClass({ 'd-none': _ctx.emailFormDisplay })
            }, [
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.userProfile.email), 1)
            ], 2),
            _createElementVNode("div", {
              id: "kt_signin_email_edit",
              class: _normalizeClass([{ 'd-none': !_ctx.emailFormDisplay }, "flex-row-fluid"])
            }, [
              _createVNode(_component_Form, {
                id: "kt_signin_change_email",
                class: "form",
                novalidate: "novalidate",
                onSubmit: _ctx.updateEmail,
                "validation-schema": _ctx.changeEmail
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.translate("ENTER_NEW_EMAIL")), 1),
                        _createVNode(_component_Field, {
                          type: "email",
                          class: "form-control form-control-lg fw-bold fs-6",
                          id: "email",
                          placeholder: _ctx.translate('ENTER_NEW_EMAIL'),
                          name: "email"
                        }, null, 8, ["placeholder"]),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _createVNode(_component_ErrorMessage, { name: "email" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.translate("CONFIRM_PASSWORD")), 1),
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg fw-bold fs-6",
                          name: "password",
                          id: "password"
                        }),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_component_ErrorMessage, { name: "password" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("button", _hoisted_48, [
                      _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.translate("BUTTON_SAVE_CHANGES")), 1),
                      _createElementVNode("span", _hoisted_50, [
                        _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_WAIT")) + " ", 1),
                        _hoisted_51
                      ])
                    ], 512),
                    _createElementVNode("button", {
                      id: "kt_signin_cancel",
                      type: "button",
                      class: "btn fw-bold btn-outline",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.emailFormDisplay = !_ctx.emailFormDisplay))
                    }, _toDisplayString(_ctx.translate("BUTTON_DISCARD_CHANGES")), 1)
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"])
            ], 2),
            _createElementVNode("div", {
              id: "kt_signin_email_button",
              class: _normalizeClass([{ 'd-none': _ctx.emailFormDisplay }, "ms-auto"])
            }, [
              _createElementVNode("button", {
                class: "btn btn-dark-blue fw-boldest px-6",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.emailFormDisplay = !_ctx.emailFormDisplay))
              }, _toDisplayString(_ctx.translate("BUTTON_CHANGE_EMAIL")), 1)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", {
              id: "kt_signin_password",
              class: _normalizeClass({ 'd-none': _ctx.passwordFormDisplay })
            }, _hoisted_55, 2),
            _createElementVNode("div", {
              id: "kt_signin_password_edit",
              class: _normalizeClass(["flex-row-fluid", { 'd-none': !_ctx.passwordFormDisplay }])
            }, [
              _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.translate("FEEDBACK_PASSWORD_TOO_SHORT")), 1),
              _createVNode(_component_Form, {
                id: "kt_signin_change_password",
                class: "form",
                novalidate: "novalidate",
                onSubmit: _ctx.updatePassword,
                "validation-schema": _ctx.changePassword
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.translate("CONFIRM_PASSWORD")), 1),
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg fw-bold fs-6",
                          name: "currentpassword",
                          id: "currentpassword"
                        }),
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("div", _hoisted_62, [
                            _createVNode(_component_ErrorMessage, { name: "currentpassword" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.translate("NEW_PASSWORD")), 1),
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg fw-bold fs-6",
                          name: "newpassword",
                          id: "newpassword"
                        }),
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _createVNode(_component_ErrorMessage, { name: "newpassword" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.translate("CONFIRM_NEW_PASSWORD")), 1),
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg fw-bold fs-6",
                          name: "confirmpassword",
                          id: "confirmpassword"
                        }),
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, [
                            _createVNode(_component_ErrorMessage, { name: "confirmpassword" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("button", _hoisted_74, [
                      _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.translate("BUTTON_SAVE_CHANGES")), 1),
                      _createElementVNode("span", _hoisted_76, [
                        _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_WAIT")) + " ", 1),
                        _hoisted_77
                      ])
                    ], 512),
                    _createElementVNode("button", {
                      id: "kt_password_cancel",
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                      class: "btn fw-bold btn-outline"
                    }, _toDisplayString(_ctx.translate("BUTTON_DISCARD_CHANGES")), 1)
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"])
            ], 2),
            _createElementVNode("div", {
              id: "kt_signin_password_button",
              class: _normalizeClass(["ms-auto", { 'd-none': _ctx.passwordFormDisplay }])
            }, [
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                class: "btn btn-dark-blue fw-boldest"
              }, _toDisplayString(_ctx.translate("BUTTON_CHANGE_PASSWORD")), 1)
            ], 2)
          ])
        ])
      ])
    ])
  ]))
}